document.addEventListener("DOMContentLoaded", async function () {
  const productBundleWrapper = document.querySelector(
    ".product-bundle__wrapper"
  );
  const currentCurrencyPrice = Shopify.currency;

  const sectionID = productBundleWrapper.getAttribute("section-id");
  const shopBaseUrl = `https://${window.Shopify.shop}`;

  if (productBundleWrapper) {
    const ids = productBundleWrapper.id.split(" ");
    const products = await fetchProductsByIds(ids);

    const productFormHtml = generateAddProductFormHtml(products);
    const getFullSetProductsHtml = generateUpdateProductFormHtml(products);
    const innerHTML = generateInnerHTML(
      productFormHtml,
      getFullSetProductsHtml
    );
    productBundleWrapper.innerHTML = innerHTML;

    const selectsAll = document.querySelectorAll(".product-bundle__select");
    const cartUpdateInputValueHTML = document.querySelector("#select-ids-js");
    const variantIdInputAll = document.querySelectorAll(".variant-id-input");
    const productIdInputAll = document.querySelectorAll(".product-id-input");
    const sectionIdInputAll = document.querySelectorAll(".section-id-input");

    let selectIds = {};

    const updateSelectIds = (selectedOption, index) => {
      if (!selectedOption.disabled) {
        selectIds[selectedOption.id] = 1;
        variantIdInputAll[index].value = selectedOption.id;
        productIdInputAll[index].value = selectedOption.id;
        sectionIdInputAll[index].value = `${sectionID}-${selectedOption.id}`;
      }
    };

    selectsAll.forEach((select, index) => {
      const selectedOption = select.options[select.selectedIndex];
      updateSelectIds(selectedOption, index);
    });

    const updateCartInputValue = () => {
      const reversedSelectIds = reversObj(selectIds);
      cartUpdateInputValueHTML.value = JSON.stringify(reversedSelectIds);
    };

    selectsAll.forEach((select) => {
      select.addEventListener("change", function () {
        const selectedOption = this.options[this.selectedIndex];
        const form = this.closest("form");
        const hiddenInput = form.querySelector(".variant-id-input");

        if (!selectedOption.disabled) {
          hiddenInput.value = selectedOption.id;
          selectIds[selectedOption.id] = 1;
        }

        for (let option of this.options) {
          if (option.id !== selectedOption.id && selectIds[option.id]) {
            delete selectIds[option.id];
          }
        }

        updateCartInputValue();
      });
    });

    updateCartInputValue();
  }

  function generateAddProductFormHtml(products) {
    let productFormHtml = "";
    products.forEach((product, index) => {
      const handle = product.handle;
      const imgUrl = product.images.edges[0].node.originalSrc;
      const title = product.title;
      const variants = product.variants.edges;
      const productInfo = someFieldsVariants(variants);
      const productUrl = `${shopBaseUrl}/products/${handle}`;
      const hasAvailableSizes = productInfo.sizes.some(
        (size) => size.quantity > 0 || size.currentlyNotInStock
      );

      productFormHtml += `<product-form x-data="productAddButtonForm()">
          <div data-product-form-outer class="custom-product-bundle__product-form">
      <form method="post" action="/cart/add" id="product-form-${sectionID}-${
        productInfo.id
      }" accept-charset="UTF-8"
				class="shopify-product-form product-bundle__form" enctype="multipart/form-data" data-product-form class='product-bundle__form'>
				<input type="hidden" name="form_type" value="product">
				<input type="hidden" name="utf8" value="✓">

				<div class='product-bundle__content'>
					<div class='product-bundle__img-wrap'>
						<a href="${productUrl}">
							<img class='product-bundle__img'
							src='${imgUrl}' loading='lazy' alt='${title}' width="100%" height="auto" />
						</a>
					</div>
					<div class="product-bundle__content-wrap">
						<div class="product-bundle__info-wrap">
							<div class="product-bundle__title-wrap">
							  <a href="${productUrl}">
								  <p class="product-bundle__title">${title}</p>
							  </a>
							</div>
							${generatePriceHtml(productInfo)}
						</div>
						${generateSelectHtml(productInfo.sizes, index)}
						<div class="product-bundle__inner" data-form-inner>
							<div class="product-bundle__wrapper" data-buttons-wrapper data-add-action-wrapper data-error-boundary>
								<div data-error-display role="alert" class="add-action-errors"></div>
								<div class="product-bundle__btn-wrap">
									
								${generateButtonFormHtml(
                  "add",
                  `${
                    !hasAvailableSizes ? "button-disabled" : ""
                  } product-bundle__btn product-bundle__btn-js`,
                  "ADD",
                  null
                )}                
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="shop-pay-terms"></div>
				<input type="hidden" name="id" value="${
          productInfo.id
        }" class="variant-id-input">
				<input type="hidden" name="product-id" value="${
          productInfo.id
        }" class="product-id-input">
				<input type="hidden" name="section-id" value="${sectionID}-${
        productInfo.id
      }" class="section-id-input">
    </form>
      </div>
          </product-form>`;
    });

    return productFormHtml;
  }

  function generateUpdateProductFormHtml(products) {
    const totalSum = products.reduce((sum, product) => {
      const variants = product.variants.edges;
      const productInfo = someFieldsVariants(variants);

      const allVariantsQuantityZero = productInfo.sizes.every(
        (variant) => variant.quantity <= 0 && !variant.currentlyNotInStock
      );

      if (!allVariantsQuantityZero) {
        sum += parseFloat(productInfo.price);
      }

      return sum;
    }, 0);
    const sumFix = convertPrice(totalSum);

    const total = `${getCurrencySymbol()}${sumFix}`;

    return `<product-form x-data="productUpdateButtonForm()">
		<div data-product-form-outer class="custom-product-bundle__product-form">
			<form method="post" action="/cart/update" id="product-form-${sectionID}" accept-charset="UTF-8" class="shopify-product-form product-bundle__form-full" enctype="multipart/form-data" data-product-form >
				<input type="hidden" name="form_type" value="product">
				<input type="hidden" name="utf8" value="✓">
                <input type="hidden" name="updates" value="" id="select-ids-js">
						<div class="product-bundle__inner" data-form-inner>
							<div class="product-bundle__wrapper" data-buttons-wrapper data-add-action-wrapper data-error-boundary>
								<div data-error-display role="alert" class="add-action-errors"></div>
								<div class="product-bundle__btn-wrap">
									
									${generateButtonFormHtml(
                    "update",
                    "product-bundle__btn-full-set",
                    "SHOP THE LOOK",
                    total
                  )}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="shop-pay-terms"></div>
			</form>
		</div>
	</product-form>`;
  }

  function generateSelectHtml(sizes, index) {
    const hasAvailableSizes = sizes.some(
      (size) => size.quantity > 0 || size.currentlyNotInStock
    );

    return `<div class="product-bundle__select-wrap">
            <select name="size" id="product-bundle__select-id-${index}" class="product-bundle__select">
              ${
                hasAvailableSizes
                  ? `${sizes
                      .map((size) => {
                        if (size.quantity <= 0 && !size.currentlyNotInStock) {
                          return `<option value='${size.size}' id='${size.id}' disabled>${size.size} - Sold out</option>`;
                        } else {
                          return `<option value='${size.size}' id='${size.id}'>${size.size}</option>`;
                        }
                      })
                      .join("")}`
                  : `<option value='${sizes[0].size}' id='-1'>Sold out</option>`
              }
            </select>
          </div>`;
  }

  function generatePriceHtml(productInfo) {
    const price = parseFloat(productInfo.price);
    const compareAtPrice = parseFloat(productInfo.compareAtPrice);
    let formattedPrice;
    let formattedCompareAtPrice;

    if (!isNaN(price)) {
      formattedPrice = convertPrice(price);
    }

    if (!isNaN(compareAtPrice)) {
      formattedCompareAtPrice = convertPrice(compareAtPrice);
    }

    return `<div class="product-bundle__price-wrap">
								<p class="product-bundle__price-final"><span class="product-bundle__price-currency">${getCurrencySymbol()}</span>${formattedPrice}</p>
								${
                  productInfo.compareAtPrice &&
                  productInfo.compareAtPrice !== "0.0"
                    ? `<p class="product-bundle__price-compare"><span class="product-bundle__price-currency">${getCurrencySymbol()}</span>${formattedCompareAtPrice}</p>`
                    : ""
                }
							</div>`;
  }

  function generateButtonFormHtml(name, classes, title, totalSum) {
    return `<div class="product-bundle__inner" data-form-inner>
		<div class="product-bundle__wrapper" data-buttons-wrapper data-add-action-wrapper data-error-boundary>
			<div data-error-display role="alert" class="add-action-errors"></div>
			<div class="product-bundle__btn-wrap">
				<button type="submit" name="${name}" class="${classes}" data-add-to-cart
					aria-label="Add to cart" :class="{
'has-success': isSuccess,
'loading': isLoading
}" >
					<span class="btn-state-ready">
                         ${
                           totalSum
                             ? `<span class="product-bundle__btn-hover">
                               ${title} <span class='product-bundle__bubble'></span> ${totalSum}
                             </span>`
                             : `<span>${title}</span>`
                         }
						
					</span>

					<span class="btn-state-loading">
						<svg height="18" width="18" class="svg-loader">
							<circle r="7" cx="9" cy="9"></circle>
							<circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
						</svg>
					</span>

					<span class="btn-state-complete"></span>
				</button>
			</div>
		</div>
	</div>`;
  }

  function generateInnerHTML(listProducts, fullSetProducts) {
    let innerHtml = `<div class="forms-wrapper">
                        ${listProducts}  ${fullSetProducts}
                     </div>`;
    return innerHtml;
  }

  function someFieldsVariants(variants) {
    if (!variants) {
      return [];
    }

    const sizes = variants.map(({ node }) => ({
      id: parseInt(node.id.split("/").pop()),
      availableForSale: node.availableForSale,
      size: node.title,
      quantity: node.quantityAvailable,
      currentlyNotInStock: node.currentlyNotInStock,
    }));

    const { price, compareAtPrice, id } = variants[0].node;

    return {
      id: parseInt(id.split("/").pop()),
      price: price.amount,
      compareAtPrice: compareAtPrice ? compareAtPrice.amount : null,
      currencyCode: price.currencyCode,
      sizes: sizes,
    };
  }

  async function fetchProductsByIds(ids) {
    const storefrontAccessToken = "3089fab2cdab2b04cfd111dd87b47d33";
    const shop = `${shopBaseUrl}/api/2023-10/graphql.json`;
    const query = `
      {
        nodes(ids: ${JSON.stringify(
          ids.map((id) => `gid://shopify/Product/${id}`)
        )}) {
          ... on Product {
            id
            title
            handle
            variants(first: 20) {
              edges {
                node {
                  id
                  title
                  currentlyNotInStock
                  price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  availableForSale
                  quantityAvailable
                }
              }
            }
            images(first: 20) {
              edges {
                node {
                  id
                  originalSrc
                  altText
                }
              }
            }
          }
        }
      }`;

    try {
      const response = await fetch(shop, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
        },
        body: JSON.stringify({ query }),
      });

      const result = await response.json();
      if (result.errors) {
        console.error("GraphQL errors: ", result.errors);
        return [];
      }
      return result.data.nodes;
    } catch (error) {
      console.error("Error fetching products: ", error);
      return [];
    }
  }

  function convertPrice(price) {
    if (!isNaN(price)) {
      const newPrice = price * currentCurrencyPrice.rate;
      return newPrice.toFixed(2);
    }
    return price;
  }

  function reversObj(obj) {
    return Object.keys(obj)
      .reverse()
      .reduce((acc, key) => {
        acc[key] = obj[key];
        return acc;
      }, {});
  }

  function getCurrencySymbol() {
    const symbols = {
      AED: "د.إ",
      AFN: "؋",
      ALL: "L",
      AMD: "֏",
      ANG: "ƒ",
      AOA: "Kz",
      ARS: "$",
      AUD: "A$",
      AWG: "ƒ",
      AZN: "₼",
      BAM: "KM",
      BBD: "$",
      BDT: "৳",
      BGN: "лв",
      BHD: ".د.ب",
      BIF: "FBu",
      BMD: "$",
      BND: "$",
      BOB: "Bs.",
      BRL: "R$",
      BSD: "$",
      BTN: "Nu.",
      BWP: "P",
      BYR: "Br",
      BZD: "$",
      CAD: "C$",
      CDF: "FC",
      CHF: "CHF",
      CLP: "$",
      CNY: "¥",
      COP: "$",
      CRC: "₡",
      CUP: "₱",
      CVE: "$",
      CZK: "Kč",
      DJF: "Fdj",
      DKK: "kr",
      DOP: "RD$",
      DZD: "د.ج",
      EGP: "£",
      ETB: "Br",
      EUR: "€",
      FJD: "$",
      FKP: "£",
      GBP: "£",
      GEL: "₾",
      GHS: "₵",
      GIP: "£",
      GMD: "D",
      GNF: "FG",
      GTQ: "Q",
      GYD: "$",
      HKD: "HK$",
      HNL: "L",
      HRK: "kn",
      HTG: "G",
      HUF: "Ft",
      IDR: "Rp",
      ILS: "₪",
      INR: "₹",
      IQD: "ع.د",
      IRR: "﷼",
      ISK: "kr",
      JMD: "J$",
      JOD: "د.ا",
      JPY: "¥",
      KES: "KSh",
      KGS: "лв",
      KHR: "៛",
      KMF: "CF",
      KPW: "₩",
      KRW: "₩",
      KWD: "د.ك",
      KYD: "$",
      KZT: "₸",
      LAK: "₭",
      LBP: "ل.ل",
      LKR: "Rs",
      LRD: "$",
      LSL: "L",
      LTL: "Lt",
      LVL: "Ls",
      LYD: "ل.د",
      MAD: "د.م.",
      MDL: "L",
      MGA: "Ar",
      MKD: "ден",
      MMK: "K",
      MNT: "₮",
      MOP: "P",
      MRO: "UM",
      MUR: "₨",
      MVR: "Rf",
      MWK: "MK",
      MXN: "$",
      MYR: "RM",
      MZN: "MT",
      NAD: "$",
      NGN: "₦",
      NIO: "C$",
      NOK: "kr",
      NPR: "₨",
      NZD: "NZ$",
      OMR: "﷼",
      PAB: "B/.",
      PEN: "S/.",
      PGK: "K",
      PHP: "₱",
      PKR: "₨",
      PLN: "zł",
      PYG: "Gs",
      QAR: "﷼",
      RON: "lei",
      RSD: "Дин.",
      RUB: "₽",
      RWF: "FRw",
      SAR: "﷼",
      SBD: "$",
      SCR: "₨",
      SDG: "£",
      SEK: "kr",
      SGD: "S$",
      SHP: "£",
      SLL: "Le",
      SOS: "S",
      SRD: "$",
      STD: "Db",
      SYP: "£",
      SZL: "L",
      THB: "฿",
      TJS: "ЅМ",
      TMT: "m",
      TND: "د.ت",
      TOP: "T$",
      TRY: "₺",
      TTD: "TT$",
      TWD: "NT$",
      TZS: "TSh",
      UAH: "₴",
      UGX: "USh",
      USD: "$",
      UYU: "$U",
      UZS: "лв",
      VEF: "Bs",
      VND: "₫",
      VUV: "VT",
      WST: "WS$",
      XAF: "FCFA",
      XCD: "$",
      XOF: "CFA",
      XPF: "₣",
      YER: "﷼",
      ZAR: "R",
      ZMW: "ZK",
      ZWL: "$",
    };

    return symbols[currentCurrencyPrice.active.toUpperCase()] || "$";
  }
});
